import { TextField } from '@mui/material';
import css from '../../Form/FormWrapper/FormWrapper.module.scss';
import classNames from 'classnames';
import { BaseTextFieldProps } from './BaseTextField.types';
import { GMFormWrapper } from '../../Form';

export const BaseTextField = ({
    name,
    id,
    title,
    label,
    ariaLabel,
    type,
    placeholder,
    autoFocus,
    required,
    disabled,
    capsLock,
    variant = 'standard',
    ref,
    inputRef,
    value,
    inputMode,
    touched,
    error,
    multiline,
    minRows,
    maxRows,
    InputProps,
    inputProps,
    InputLabelProps,
    onBlur,
    onChange,
    onFocus,
    onKeyDown,
    safariHack,
    sx,
    fullWidth,
    seventyFivePercentWidth,
}: BaseTextFieldProps) => {
    return (
        <GMFormWrapper fullWidth={fullWidth} seventyFivePercentWidth={seventyFivePercentWidth}>
            <TextField
                ref={ref}
                variant={variant}
                name={name}
                id={id}
                title={title}
                label={label}
                aria-label={ariaLabel}
                inputRef={inputRef}
                type={type}
                value={value}
                placeholder={placeholder}
                multiline={multiline}
                minRows={minRows}
                maxRows={maxRows}
                autoFocus={autoFocus}
                required={required}
                disabled={disabled}
                error={touched && !!error}
                helperText={touched ? error : undefined}
                onBlur={onBlur}
                onChange={onChange}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
                classes={{
                    root: css.textField,
                }}
                sx={{
                    ...sx,
                }}
                InputLabelProps={{
                    ...InputLabelProps,
                    classes: {
                        root: classNames(css.label, css[safariHack]),
                        focused: css.focused,
                        error: css.error,
                    },
                }}
                InputProps={{
                    ...InputProps,
                    classes: { root: css.input,
                        error: css.error,
                        input: css.baseInput },
                }}
                inputProps={{
                    ...inputProps,
                    inputMode: inputMode,
                    style: {
                        ...inputProps?.style,
                        textTransform: !!capsLock ? 'uppercase' : 'unset',
                    },
                }}
                FormHelperTextProps={{ classes: { root: classNames(css.errorMessage, css[safariHack]) } }}
                onCompositionStart={() => inputRef?.current?.classList.add('inComposition')}
                onCompositionEnd={() => inputRef?.current?.classList.remove('inComposition')}
            />
        </GMFormWrapper>
    );
};